import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import PropTypes from 'prop-types';

var ModalHeader =
/*#__PURE__*/
function (_Component) {
  _inherits(ModalHeader, _Component);

  function ModalHeader(props) {
    var _this;

    _classCallCheck(this, ModalHeader);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ModalHeader).call(this, props)); // warn if something is wrong with props

    _defineProperty(_assertThisInitialized(_this), "onCancel", function (e) {
      /* istanbul ignore else */
      if (e && e.preventDefault) {
        e.preventDefault();
      }

      var _this$props = _this.props,
          isStatic = _this$props.isStatic,
          onCancel = _this$props.onCancel;

      if (!isStatic && onCancel) {
        onCancel(e, null);
      }
    });

    if (props.addClose && !props.onCancel) {
      // eslint-disable-next-line no-console
      console.warn("".concat(ModalHeader.displayName, ": addClose is defined but onCancel is missing!"));
    }

    return _this;
  }

  _createClass(ModalHeader, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          addClose = _this$props2.addClose,
          className = _this$props2.className;

      if (typeof children !== 'string') {
        return children;
      }

      var closeBtn = addClose ? React.createElement("button", {
        className: "tg-modal-close",
        "aria-label": "Close",
        type: "button",
        onClick: this.onCancel
      }, React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7")) : null;
      return React.createElement("div", {
        className: className
      }, React.createElement("h1", {
        className: "tg-modal-title"
      }, children), closeBtn);
    }
  }]);

  return ModalHeader;
}(Component);

ModalHeader.displayName = 'Modal.Header';
ModalHeader.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  isStatic: PropTypes.bool,
  addClose: PropTypes.bool,
  onCancel: PropTypes.func
};
ModalHeader.defaultProps = {
  addClose: true,
  children: null,
  className: 'tg-modal-header',
  isStatic: false,
  onCancel: null
};
export default ModalHeader;